// Persists the query string of a filtered listing page (keyed by its pathname) in sessionStorage,
// so links back to that page (e.g. breadcrumbs) can restore the filter that was active when the
// user navigated away from it.

const STORAGE_KEY_PREFIX = "postOverviewFilter:";

export const getStoredFilterValue = (path: string): string | null => {
  if (typeof window === "undefined") return null;
  return window.sessionStorage.getItem(`${STORAGE_KEY_PREFIX}${path}`);
};

export const setStoredFilterValue = (path: string, value: string): void => {
  if (typeof window === "undefined") return;

  const key = `${STORAGE_KEY_PREFIX}${path}`;
  if (value) {
    window.sessionStorage.setItem(key, value);
  } else {
    window.sessionStorage.removeItem(key);
  }
};

// Persists the scroll position of a listing page (keyed by its pathname) in sessionStorage, so
// navigating back to it (e.g. via breadcrumbs) can restore the position the user scrolled to,
// the same way the browser's back button would.

const SCROLL_STORAGE_KEY_PREFIX = "postOverviewScroll:";

export const getStoredScrollPosition = (path: string): number | null => {
  if (typeof window === "undefined") return null;
  const value = window.sessionStorage.getItem(
    `${SCROLL_STORAGE_KEY_PREFIX}${path}`
  );
  return value ? Number(value) : null;
};

export const setStoredScrollPosition = (path: string, value: number): void => {
  if (typeof window === "undefined") return;
  window.sessionStorage.setItem(
    `${SCROLL_STORAGE_KEY_PREFIX}${path}`,
    String(value)
  );
};

// Persists how many pages of results were expanded via the "Show more" button on a listing page
// (keyed by its pathname) in sessionStorage, so navigating back to it (e.g. via breadcrumbs)
// restores the same number of visible items.

const PAGE_STORAGE_KEY_PREFIX = "postOverviewPage:";

export const getStoredCurrentPage = (path: string): number | null => {
  if (typeof window === "undefined") return null;
  const value = window.sessionStorage.getItem(
    `${PAGE_STORAGE_KEY_PREFIX}${path}`
  );
  return value ? Number(value) : null;
};

export const setStoredCurrentPage = (path: string, value: number): void => {
  if (typeof window === "undefined") return;
  window.sessionStorage.setItem(
    `${PAGE_STORAGE_KEY_PREFIX}${path}`,
    String(value)
  );
};
